import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MoneyIcon from 'assets/icons/money-unit-border.png'
import ActionButton from 'components/Shared/ActionButton'

const VARIANTS = ['positive', 'negative']

function PlantActionButton(props) {
  const { callAction, className, cost, text, variant } = props

  const { t } = useTranslation()

  const buttonCost = () => (
    <>
      <div className="flex-row">
        <img src={MoneyIcon} alt="Money icon" className="plant-action-button__coin" />

        <div className="plant-action-button__cost">{`${cost} ${t('money_unit.mu')}`}</div>
      </div>
      <div
        className={`plant-action-button__separator plant-action-button__separator--${variant}`}
      />
    </>
  )

  return (
    <ActionButton
      className={`plant-action-button ${className}`}
      handleOnClick={callAction}
      variant={variant}
    >
      <div className="flex-row align-center justify-center">
        {cost && buttonCost(variant)}
        {text}
      </div>
    </ActionButton>
  )
}

PlantActionButton.propTypes = {
  callAction: PropTypes.func.isRequired,
  className: PropTypes.string,
  cost: PropTypes.oneOfType(PropTypes.number, PropTypes.string).isRequired,
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(VARIANTS)
}

PlantActionButton.defaultProps = {
  className: '',
  variant: VARIANTS[0]
}

export default memo(PlantActionButton)
